// EmailJS Configuration
// 
// SETUP INSTRUCTIONS:
// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Add an Email Service (e.g., Gmail, Outlook) in the "Email Services" tab
// 3. Create an Email Template in the "Email Templates" tab
// 4. Copy your Service ID, Template ID, and Public Key below
//
// TEMPLATE VARIABLES (use these in your EmailJS template):
// {{from_name}} - Sender's name
// {{from_email}} - Sender's email
// {{company}} - Company name
// {{phone}} - Phone number
// {{subject}} - Subject/Topic
// {{message}} - Message content
// {{duration}} - Selected consultation duration (for consultation form)
// {{preferred_time}} - Preferred time slot (for consultation form)

export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_xcxsa4s',
  TEMPLATE_ID_CONSULTATION: 'template_p2oev5b',
  TEMPLATE_ID_CONTACT: 'template_hcw3s4s',
  PUBLIC_KEY: 'AMbXitmor0UCZ0_5e',
};

// Email recipient
export const RECIPIENT_EMAIL = 'info@integrovaai.de';

// Check if EmailJS is configured
export const isEmailConfigured = (): boolean => {
  return (
    EMAIL_CONFIG.SERVICE_ID !== 'YOUR_SERVICE_ID' &&
    EMAIL_CONFIG.PUBLIC_KEY !== 'YOUR_PUBLIC_KEY'
  );
};
